module.exports = __webpack_public_path__ + "static/template_3_review-303c01e7a690958e9b4ab637c8a5b667.png";